'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import ButtonBox from '../../button/ButtonBox.mjs';
import ButtonBoxDouble from '../../button/ButtonBoxDouble.mjs';
import DimmedLayer from '../../common/DimmedLayer.mjs';
import { BUTTON_BOX_SIZE } from '../../../constants/button.mjs';
import { MODAL_CATEGORY, MODAL_ID, CENTER_MODAL_TYPE } from '../../../constants/modal.mjs';
import { useModalStore, useCenterModal, modalInternal } from '../../../contexts/ModalContext.mjs';
import styles from './CenterModalWrapper.module.scss.mjs';

const cx = classNames.bind(styles);
const CenterModalWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _buttons$leftButton, _buttons$rightButton;
  let {
    children,
    type,
    button,
    buttons,
    onClickDimmedLayer
  } = _ref;
  const {
    modals
  } = useModalStore();
  const {
    close
  } = useCenterModal();
  const centerModal = modals.find(m => m.category === MODAL_CATEGORY.CENTER);
  const {
    isOpen = false,
    isShow = false,
    toBeDestroyed = false
  } = centerModal ?? {};
  const handleTransitionEnd = () => toBeDestroyed && modalInternal.destroy(MODAL_CATEGORY.CENTER);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article'),
    onTransitionEnd: handleTransitionEnd,
    ...(isOpen ? {
      tabIndex: 0
    } : {})
  }, isShow && ( /*#__PURE__*/React.createElement("div", {
    className: cx('modal-body'),
    ref: ref,
    id: MODAL_ID.CENTER_MODAL
  }, children, type === CENTER_MODAL_TYPE.NOTICE && button && ( /*#__PURE__*/React.createElement(ButtonBox, {
    ...button,
    onClick: (button === null || button === void 0 ? void 0 : button.onClick) ?? close,
    size: BUTTON_BOX_SIZE.LARGE,
    isWide: true
  })), type === CENTER_MODAL_TYPE.CONFIRM && buttons && ( /*#__PURE__*/React.createElement(ButtonBoxDouble, {
    size: BUTTON_BOX_SIZE.LARGE,
    ratio: buttons.ratio,
    leftButton: {
      ...buttons.leftButton,
      onClick: ((_buttons$leftButton = buttons.leftButton) === null || _buttons$leftButton === void 0 ? void 0 : _buttons$leftButton.onClick) ?? close
    },
    rightButton: {
      ...buttons.rightButton,
      onClick: ((_buttons$rightButton = buttons.rightButton) === null || _buttons$rightButton === void 0 ? void 0 : _buttons$rightButton.onClick) ?? close
    }
  })))), /*#__PURE__*/React.createElement(DimmedLayer, {
    isShow: isShow,
    onClick: onClickDimmedLayer ?? close
  }));
});
CenterModalWrapper.displayName = 'CenterModalWrapper';

export { CenterModalWrapper as default };
